/**
 * For every layer property, there should be a default value.
 * This is needed e.g. when a feature is added (e.g. CSS gradients),
 * which were not originally there in the card template.
 *
 * There are two types of defaults – global layer defaults (these here)
 * and theme defaults, defined inside each card.
 *
 * GLOBAL DEFAULT -> THEME DEFAULT -> ACTUAL CARD DATA
 *
 * These values might never be visible in the front-end, but act as a fallback
 */

import directions from './directions';

const textLayerDefaults = {
  fontName: '',
  fontSize: 20,
  lineHeight: 1.2, // most browser use a value close to this as default
  fontWeight: 400,
  fontStyle: 'normal',
  alignmentX: directions.CENTER,
  alignmentY: directions.CENTER,
  color: '#000000',
  text: 'Ihr Text hier',
};

const fotoLayerDefaults = {
  filterBrightness: 1, // = 100% = normal, maps to CSS: "filter: brightness(1)"
  filterContrast: 1, // = 100% = normal, maps to CSS: "filter: contrast(1)"
  filterGrayscaleActive: false,
  filterSepiaActive: false,
  imageUrl: '',
  transformRotate: 0,
  transformScale: 1, // 100% width, TODO: might need to be fixed if height > width
  transformTranslateX: 0,
  transformTranslateY: 0,

};

export default {
  textLayerDefaults,
  fotoLayerDefaults,
};
